window.addEventListener( 'load', function() {

	function toggleToggleItem( button ) {
		const toggleContent = document.getElementById( button.getAttribute( 'aria-controls' ) );
		if ( toggleContent ) {            
			if ( 'false' === button.getAttribute( 'aria-expanded' ) ) {
                // close others on open
                const parent = button.closest( '.wp-block-toggles' );
                const toggleItems = parent.querySelectorAll( '.wp-block-toggle__button' );
                [...toggleItems].forEach( toggleItem => {
                    const toggleContent = document.getElementById( toggleItem.getAttribute( 'aria-controls' ) );
                    toggleItem.setAttribute( 'aria-expanded', false );
				    toggleContent.classList.remove( 'active' );		
                } );
				button.setAttribute( 'aria-expanded', true );
				toggleContent.classList.add( 'active' );
			} else {
				button.setAttribute( 'aria-expanded', false );
				toggleContent.classList.remove( 'active' );
			}
		}
	}

	const toggleItemsButtons = document.querySelectorAll( '.wp-block-toggle__button' );
	[...toggleItemsButtons].forEach( toggleItemButton => {
		toggleItemButton.addEventListener( 'click', e => {
			e.preventDefault();
			toggleToggleItem( toggleItemButton );
		} );
	} );

} );